// extracted by mini-css-extract-plugin
export default {"header":"recommendations--3U5Jl","header__primary":"recommendations--15VK5","header__secondary":"recommendations--2ibLl","header__secondary--not-logged-in":"recommendations--O5zKN"};